module.exports = __webpack_public_path__ + "img/img-parts-senaka01.ada0e13a.png";